/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */
import store from '@/store';
import * as api from '@/api/play';
import { PLAY } from '@/store/types';
import { snakelize } from '@/utils/transfer';
import { createPayment } from '@/utils/create-payment';
import listModule, { StorePlayOrderListState } from './list';
import detailModule, { StorePlayOrderDetailState } from './detail';

export interface StorePlayOrderState {
  // modules
  list: StorePlayOrderListState;
  detail: StorePlayOrderDetailState;
}

export default {
  namespaced: true,
  modules: {
    list: listModule,
    detail: detailModule,
  },
  state: {},
  getters: {},
  actions: {
    [PLAY.CREATE_ORDER](_, { serviceId, num, silent }) {
      return new Promise((resolve, reject) => {
        const data = snakelize({
          serviceId,
          num,
        });
        createPayment(() => api.postOrder(data, silent)).then((res) => {
          store.dispatch(`play/order/list/${PLAY.GET_ORDER_LIST}`, {
            filter: 'consumed',
            action: 'fetch',
          });
          resolve(res);
        }).catch(reject);
      });
    },
    [PLAY.PUT_ORDER](_, { id, body, silent }) {
      return new Promise((resolve, reject) => {
        api.putOrder(id, body, silent).then((res) => {
          if (body.action === 'delete') {
            store.commit(`play/order/list/${PLAY.UPDATE_ORDER}`, { id });
            store.commit(`play/order/detail/${PLAY.UPDATE_ORDER}`, { id });
            resolve(res);
          } else {
            store.dispatch(`play/order/detail/${PLAY.GET_ORDER}`, {
              id,
              fetch: true,
            }).then(() => resolve(res));
          }
        }).catch((err) => {
          store.dispatch(`play/order/detail/${PLAY.GET_ORDER}`, {
            id,
            refresh: true,
          });
          reject(err);
        });
      });
    },
    [PLAY.POST_APPRAISE](_, { orderId, numStar, content, isFamous }) {
      return new Promise((resolve, reject) => {
        const body = snakelize<{
          isFamous?: boolean;
        }>({
          orderId,
          numStar,
          content,
        });
        body.isFamous = isFamous;
        api.postAppraise(body).then((res) => {
          store.dispatch(`play/order/detail/${PLAY.GET_ORDER}`, {
            id: orderId,
            fetch: true,
          }).then(() => resolve(res));
        }).catch(reject);
      });
    },
    [PLAY.POST_COMPLAINT](_, { type, target, content, remark }) {
      return new Promise((resolve, reject) => {
        api.postComplaint({ type, target, content, remark }).then((res) => {
          if (type === 'order') {
            store.dispatch(`play/order/detail/${PLAY.GET_ORDER}`, {
              id: target,
              refresh: true,
            }).then(() => resolve(res));
          } else {
            resolve(res);
          }
        }).catch(reject);
      });
    },
  },
  mutations: {},
};
